import { useState, useEffect } from "react";
import {getMessageInt, actualizaMessage} from '../../services/mensaje';
import { ErrorContext } from "../../utils/context/error";
import PropTypes from 'prop-types';
import Modal from "../modal";

function MessageModal({ show, AreaI, AreaFId ,MensajeI, Tag, handleshow, handleFiltrar }) {

  const [areaId, setAreaId] = useState(0);
  const [mensajeId, setMensajeId] = useState(0);
  const [mensaje, setMensaje]= useState("");
  const [Titulo, setTitulo] = useState("");
  const [habilita, setHabilita] = useState(false);
  const [validar, setValidar] = useState(false);
  const [area, setArea] = useState([]);
      
  const { setShowToast, setOpciones } = ErrorContext();
  //-----------------------------------
  const handleCancel = async () => 
    {
      handleshow(false);
    };
  //-----------------------------------
  const handleAceptar = async () => 
    {
      setHabilita(true);
      setShowToast(false);
      
      setValidar(false);
      if (areaId >0 && mensaje !=='')
      {  
        const response = await actualizaMessage({
          areaId,
          mensajeId,
          mensaje,
          Tag,
         });
       
        if (response) 
         {
           if (response.status === 200) 
             {
               if (Tag ===2)
                handleFiltrar([]);
               else 
                 handleFiltrar(response?.data?.data[0]);
               handleshow(false);
               setValidar(false);
             } 
           else 
           {
             const Mensaje = response.message;
             const opc = { type: "Danger", message: Mensaje, active: true };
             setOpciones(opc);
             setShowToast(true);
             setHabilita(false);
           }
         }
       }
      else
       setValidar(true);

    setHabilita(false);
    
  };
  //--------------------------------------------
  const fillMessageInt = async (AreaId, MensajeI) => 
    {
      setShowToast(false);
      const response = await getMessageInt(AreaId, MensajeI);
      if (response) 
        {
          if (response.status === 200) 
            {
              setMensaje(response.data.data[0]?.Mensaje||"");
              setAreaId(AreaI);
              setMensajeId(MensajeI);
              setArea(response.data.area);
            } 
          else 
          {
            const Mensaje = response.message;
            const opc = { type: "Danger", message: Mensaje, active: true };
            setOpciones(opc);
            setShowToast(true);
          }
        }
    };
//------------------------------------------
  useEffect(() => 
    {
      if (show) 
        {
          setMensaje("");
          setAreaId(AreaI);
          setMensajeId(MensajeI);
     
          fillMessageInt(AreaI, MensajeI);
      
          if (Tag !== 0) 
            {
               if (Tag === 1) setTitulo("Editar Mensaje (" + MensajeI + ")");
               if (Tag === 2) setTitulo("Eliminar Mensaje (" + MensajeI + ")");
            } 
          else 
           {
             setMensajeId(0);
             setTitulo("Nuevo Mensaje");
           }
        }
    }, [show]);

  return (
    <>
     <Modal isOpen={show} onClose={()=>handleshow(false)} title={Titulo}>
        <div className="flex lg:w-[26rem]">
            <form noValidate className="flex flex-col w-full">
                <div className="flex flex-col w-full h-full ">
                   <div className="w-full">
                      <label>Area</label>
                      <select id="area" name="area" value={areaId || 0} 
                              onChange={(e) => setAreaId(e.target.value)} 
                              label="Area" disabled={Tag === 2 || Tag === 1}
                              className={`${validar && areaId === 0 ? `validar`: ""}`}>
                        <option value={0} disabled>
                           Seleccionar una Area...
                        </option>
                        {area.map((item) => 
                          {
                            return(
                              <option key={item.AreaId} value={item.AreaId}>
                                  {item.NombreArea}
                              </option>
                            );
                          }
                          )
                        }
                     </select>
                     {validar && areaId === 0 && (
                       <p className={`text-red-500 text-[0.6rem] font-medium italic`}>
                           * Campo Obligatorio.
                       </p>
                      )}
                   </div>
                   <div className="w-full mt-4">
                         <label>Mensaje</label>
                            <textarea name='searchid' value={mensaje || ""} placeholder="Ingresa un Mensaje" 
                                onChange={(e)=> setMensaje(e.target.value)}
                                className={`${validar && mensaje === "" ? `validar`: ""}`}
                                autoComplete="off" 
                                disabled={Tag === 2}>
                            </textarea>
                            {validar && mensaje === "" && (
                               <p className={`text-red-500 text-[0.6rem] font-medium italic`}>
                                  * Campo Obligatorio.
                               </p>
                      )}
    
                   </div>
                </div>
                <div className="flex w-full gap-4 mt-6 justify-end">
                   <button name="Aceptar" className="btnprimary" onClick={handleAceptar} disabled={habilita} type="button">Aceptar</button>
                   <button name="Cancelar" className="" onClick={handleCancel} disabled={habilita} type="button">Cancelar</button>
                </div>
            </form>
        </div>           
      </Modal>
    </>
  );
}
MessageModal.propTypes = {
  show: PropTypes.bool.isRequired,
  AreaI: PropTypes.number.isRequired, 
  AreaFId: PropTypes.number.isRequired, 
  MensajeI: PropTypes.number.isRequired,
  Tag: PropTypes.number.isRequired,
  handleshow: PropTypes.func.isRequired,
  handleFiltrar: PropTypes.func.isRequired,
};

export default MessageModal;
